// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"map","718":"ics","722":"nav-subitem"}[chunkId] || chunkId) + "";
};